import _ from 'lodash-extended';
/** State -
 * Asset Editor General State Obj
 * !!!!🆇!!!!!!!!!!🆇!!!!!!!!!!!!🆇!!!!!!!!!!!!!!🆇!!!!!!!!🆇!
 * Properties SHOULD NOT be maintained directly by components
 * 🆇!!!!!!!!!🆇!!!!!!!!!!!🆇!!!!!!!!!!!🆇!!!!!!!!🆇!!!!!!!🆇!
 * @returns {Object}
 */
export default {
  openedFrom: null,
  currentPageId: null,
  workModel: null,
  initialModel: null,
  assetModel: null,
  analyticsData: null,
  themeInfo: {},
  allThemeInfos: [], // for all aspect ratios
  isStoryboard: false,
  isStoryboarder: null,
  story: {
    id: null,
    volumeSettings: null,
    aspectRatio: null,
    showVolumeDualSettings: null,
    programmer: null,
    textStyles: null,
    applyAutoTransition: null,
    bgMusic: null,
  },
  isPreOrPostNarration: null,
  rtpModel: null,
  sceneLayoutSTPModel: null,
  stp: {
    status: 'FINISH',
    src: null,
    lastChecksum: null,
  },
  stpPageIdsToIgnore: ['zoom', 'textOverlay', 'subtitles'],
  oldDuration: null,
  newDuration: null,
  playheadPosition: 0,
  timeInAsset: 0,
  defaultVolumePresets: {},
  ianToModel: null, // in asset navigation text overlay structure
  ian: {
    getAssets: _.noop,
    loop: false,
    total: 0,
    current: 0,
    isAssetTuned: true,
    instructions: {
      editTOEffect: false,
      useTOModel: null,
    },
  },
  originalAsset: {
    $ref: null,
    loading: false,
    style: {},
  },
  pageTmpState: {},
  confirmedVolumeApplyAll: false,
  isValidToLeave: true,
  validToLeavePromise: new _.ColdPromise(),
  applyVolumeToAll: false,
  shouldPreviewAutoplay: false,
  mouseDisabled: false,
  volumeState: {
    bgMusic: null,
    narration: null,
    video: null,
  },
  activeOverlayTrackGuid: null,
  overlayTrackStandAlone: false,
  tempTracks: null,
  textImportOptions: [],

  groups: [
    {
      id: 'TEXT',
      title: 'Text',
      class: 'wt-text-button',
      iconClass: 'wticon-add-text',
      doubleClick: 'textOverlay',
    },
    {
      id: 'CROP',
      title: 'Crop',
      class: 'wt-crop-button',
      iconClass: 'wticon-Crop',
      doubleClick: false,
      changePageOnGroupClick: true,
    },
    {
      id: 'ZOOM',
      title: 'Zoom',
      class: 'wt-zoom-button',
      iconClass: 'wticon-zoom-in',
      doubleClick: false,
      changePageOnGroupClick: true,
    },
    {
      id: 'OVERLAY',
      title: 'Graphics',
      class: 'wt-custom-overlays-button',
      iconClass: 'wticon-Graphics',
      doubleClick: false,
    },
    {
      id: 'EFFECT',
      title: 'Effects',
      class: 'wt-custom-effects-button',
      iconClass: 'wticon-Effect_wand',
      doubleClick: false,
    },
    {
      id: 'AUDIO',
      title: 'Audio',
      class: 'wt-audio-button',
      iconClass: 'wticon-volume-high',
      doubleClick: false,
    },
  ],

  groupsWithExclusiveCustomOverlays: ['EFFECT'],

  defaultEditorUrl: 'preview',
  showMoreInfo: false,

  mappedThemeBlockedEffects: {
    showFreeText: ['textOverlay'],
    showSuperCredit: ['super', 'credit'],
  },

  pages: [],

  volumeMuted: {},

  volumeMutedOnVoPlay: {},

  sceneDetectionEnabled: false,

  // an object tracking job is being created - shared by every apply entry point
  objectTrackingInFlight: false,
};
